import { PencilIcon } from "@heroicons/react/24/outline";
import { FC, useState } from "react";
import { DrawerComponent } from "src/components/DialogComponent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import TestProvider from "../components/Tests/store/TestProvider";
import { ITesting } from "../components/Tests/types";
import NotificationTestsMobile, {
  getStoredQuestionsCount,
} from "./NotificationTests.mobile";

interface IProps {
  onResult: (data: ITesting) => void;
  zIndex: number;
}

const SelectTestsMobile: FC<IProps> = ({ zIndex, onResult }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [testsCount, setTestsCount] = useState(getStoredQuestionsCount());

  const isEmpty = !testsCount;

  function toggleDrawer() {
    setOpenDrawer(!openDrawer);
  }

  return (
    <FlexRow
      className={twMerge(
        isEmpty ? "" : "text-black",
        "flex items-center justify-between p-5 font-medium flex-nowrap",
      )}
    >
      <FlexCol className="text-[18px] leading-[28px]">
        <span>Тестирование:</span>
        <span className="block">
          {isEmpty ? "не требуется" : `требуется, ${testsCount} вопросов`}
        </span>
      </FlexCol>
      <FlexCol className="shrink-0">
        <button onClick={toggleDrawer}>
          <PencilIcon width={24} height={24} color="#9CA3AF" />
        </button>
      </FlexCol>
      <DrawerComponent percentage="87" zIndex={zIndex} open={openDrawer} toggleDrawer={toggleDrawer}>
        <TestProvider>
          <NotificationTestsMobile
            zIndex={zIndex}
            closeTests={toggleDrawer}
            onResult={(data: ITesting) => {
              setTestsCount(data.Questions.length);
              onResult(data);
            }}
          />
        </TestProvider>
      </DrawerComponent>
    </FlexRow>
  );
};

export default SelectTestsMobile;
